var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSignInTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 33,
    viewBox: "0 0 32 33",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2559_12062)"
  }, /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M32 16.5C32 25.3366 24.8366 32.5 16 32.5C7.16344 32.5 0 25.3366 0 16.5C0 7.66344 7.16344 0.5 16 0.5C24.8366 0.5 32 7.66344 32 16.5ZM16.5734 12.3119C15.0171 12.9592 11.9068 14.2989 7.24252 16.3311C6.48511 16.6323 6.08834 16.927 6.05222 17.2151C5.99118 17.702 6.60095 17.8937 7.43129 18.1548C7.54424 18.1903 7.66127 18.2271 7.78125 18.2661C8.59818 18.5317 9.6971 18.8424 10.2684 18.8547C10.7866 18.8659 11.365 18.6523 12.0035 18.2138C16.3615 15.272 18.6112 13.7851 18.7524 13.753C18.8521 13.7304 18.9901 13.702 19.0837 13.7851C19.1772 13.8683 19.168 14.0258 19.1581 14.068C19.0977 14.3255 16.7042 16.5508 15.4655 17.7024C15.0793 18.0614 14.8054 18.316 14.7494 18.3742C14.624 18.5045 14.4962 18.6277 14.3733 18.7461C13.6144 19.4778 13.0452 20.0264 14.4048 20.9224C15.0582 21.3529 15.581 21.709 16.1026 22.0642C16.6722 22.4521 17.2404 22.839 17.9755 23.3209C18.1628 23.4437 18.3416 23.5712 18.5159 23.6954C19.1788 24.168 19.7743 24.5926 20.5101 24.5248C20.9377 24.4855 21.3793 24.0835 21.6036 22.8845C22.1336 20.0509 23.1755 13.9113 23.4163 11.3813C23.4374 11.1596 23.4108 10.876 23.3895 10.7514C23.3682 10.6269 23.3237 10.4495 23.1618 10.3181C22.9701 10.1626 22.6742 10.1298 22.5418 10.1321C21.94 10.1427 21.0167 10.4638 16.5734 12.3119Z",
    fill: "#403B37"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2559_12062"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white",
    transform: "translate(0 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignInTelegram);
export default __webpack_public_path__ + "static/media/sign_in_telegram.2e40104fafa712bf79b76dab6e96072e.svg";
export { ForwardRef as ReactComponent };